import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { reportClientEvent } from '../helpers/clientLog';

function NotFoundPage({ diagnostics }) {
  useEffect(() => {
    reportClientEvent('spa_404', diagnostics);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-white px-6 text-primary">
      <div className="absolute left-1/2 top-1/2 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary/20 blur-[140px]" />
      <div className="absolute top-20 left-20 h-40 w-40 rounded-full bg-primary/10 blur-3xl" />
      <div className="absolute bottom-20 right-20 h-56 w-56 rounded-full bg-primary/10 blur-3xl" />
      <div className="relative z-10 max-w-xl text-center">
        <div className="mb-2 text-8xl font-black tracking-tight bg-gradient-to-r from-white via-primary to-white bg-clip-text text-transparent">
          404
        </div>
        <h1 className="mb-4 text-3xl font-bold">
          Looks like you're lost.
        </h1>
        <p className="mb-8 text-slate-800">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex justify-center gap-4">
          <Link
            to="/"
            className="rounded-xl bg-white px-6 py-3 font-semibold text-primary"
          >
            Go Home
          </Link>

          <button
            onClick={() => window.history.back()}
            className="rounded-xl border border-primary px-6 py-3 text-primary"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
